export default "__VITE_ASSET__DsnWjayi__"